export type ButtonVariant = 'primary' | 'secondary' | 'soft' | 'danger';
export type ButtonSize = 'sm' | 'md';

const buttonBaseClass =
  'inline-flex items-center justify-center gap-x-1.5 rounded-md font-semibold disabled:pointer-events-none disabled:opacity-50';

const buttonVariantClass: Record<ButtonVariant, string> = {
  primary:
    'bg-accent text-on-accent shadow-xs shadow-shadow/15 hover:bg-accent-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-ink',
  secondary:
    'bg-surface text-content shadow-xs shadow-shadow/15 ring-1 ring-line ring-inset hover:bg-raised',
  soft: 'bg-accent-soft text-accent-ink hover:bg-accent/20',
  danger:
    'bg-negative-fill text-on-negative shadow-xs shadow-shadow/15 hover:bg-negative-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-negative',
};

const buttonSizeClass: Record<ButtonSize, string> = {
  md: 'px-3 py-2 text-sm',
  sm: 'px-2.5 py-1.5 text-xs',
};

export const buttonClass = (
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md',
  className?: string,
): string =>
  [buttonBaseClass, buttonVariantClass[variant], buttonSizeClass[size], className]
    .filter(Boolean)
    .join(' ');

export const labelClass = 'block text-sm/6 font-medium text-content';

export const inputClass =
  'block w-full rounded-md bg-surface px-3 py-1.5 text-base text-content outline-1 -outline-offset-1 placeholder:text-muted focus:outline-2 focus:-outline-offset-2 focus:outline-accent-ink sm:text-sm/6 dark:scheme-dark';

export const selectClass =
  'col-start-1 row-start-1 w-full appearance-none rounded-md bg-surface py-1.5 pr-8 pl-3 text-base text-content outline-1 -outline-offset-1 focus:outline-2 focus:-outline-offset-2 focus:outline-accent-ink sm:text-sm/6 *:bg-surface dark:scheme-dark';

export const outlineClass = (invalid: boolean): string =>
  invalid ? 'outline-negative' : 'outline-line';

export const hintClass = 'mt-2 text-sm text-muted';

export const fieldErrorClass = 'mt-2 text-sm text-negative';

export const dropdownItemClass = 'block px-3 py-1 text-sm/6 text-content hover:bg-raised';

export const accentLinkClass = 'font-semibold text-accent-ink hover:underline';

export const negativeLinkClass = 'font-semibold text-negative hover:underline';
